import ajax from '@ajax';

/**
 * OpenClaw Gateway API
 * OpenClaw Gateway Service API Documentation
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */
const basePath = '/marioclaw/api'.replace(/\/$/, '');
/**
  *
  * @param params ParamshealthCheck
  
  * @param opt ajax config
  * @returns string
  */
const healthCheck = (params, opt) => {
    const path = '/';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamshealthCheck1
  
  * @param opt ajax config
  * @returns string
  */
const healthCheck1 = (params, opt) => {
    const path = '/';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'HEAD',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamshealthCheck2
  
  * @param opt ajax config
  * @returns string
  */
const healthCheck2 = (params, opt) => {
    const path = '/';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamshealthCheck3
  
  * @param opt ajax config
  * @returns string
  */
const healthCheck3 = (params, opt) => {
    const path = '/';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'PUT',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamshealthCheck4
  
  * @param opt ajax config
  * @returns string
  */
const healthCheck4 = (params, opt) => {
    const path = '/';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'PATCH',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamshealthCheck5
  
  * @param opt ajax config
  * @returns string
  */
const healthCheck5 = (params, opt) => {
    const path = '/';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'DELETE',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamshealthCheck6
  
  * @param opt ajax config
  * @returns string
  */
const healthCheck6 = (params, opt) => {
    const path = '/';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'OPTIONS',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamskimEventMessageCallback
  * @param data: ParamsBodykimEventMessageCallback
  * @param opt ajax config
  * @returns {}
  */
const kimEventMessageCallback = (params, data, opt) => {
    const path = '/callback/kim/event/message';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamskimMessageCallback
  * @param data: ParamsBodykimMessageCallback
  * @param opt ajax config
  * @returns {}
  */
const kimMessageCallback = (params, data, opt) => {
    const path = '/callback/kim/message';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsagentSkillInstallUsingPost
  * @param data: ParamsBodyagentSkillInstallUsingPost
  * @param opt ajax config
  * @returns models.ApiResponseVoid
  */
const agentSkillInstallUsingPost = (params, data, opt) => {
    const path = '/agent/skill/install';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsagentSkillRagInstallUsingPost
  * @param data: ParamsBodyagentSkillRagInstallUsingPost
  * @param opt ajax config
  * @returns models.ApiResponseBoolean
  */
const agentSkillRagInstallUsingPost = (params, data, opt) => {
    const path = '/agent/skill/rag/install';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamscheckBotClaimed
  
  * @param opt ajax config
  * @returns models.ApiResponseVoid
  */
const checkBotClaimed = (params, opt) => {
    const path = '/agent/check-bot';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 必传参数:permissionMode 选填参数:memberUsernames
  * @summary 创建agent
  * @param params ParamscreateAgent
  * @param data: ParamsBodycreateAgent
  * @param opt ajax config
  * @returns models.ApiResponseAgentListVO
  */
const createAgent = (params, data, opt) => {
    const path = '/agent/create';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 必传参数:editPermissionMode,availablePermissionMode 选填参数:editMemberKwaiUserIds,availableMemberKwaiUserIds
  * @summary 创建agentV2
  * @param params ParamscreateAgentV2
  * @param data: ParamsBodycreateAgentV2
  * @param opt ajax config
  * @returns models.ApiResponseAgentListVO
  */
const createAgentV2 = (params, data, opt) => {
    const path = '/agent/createV2';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsdeleteAgent
  * @param data: ParamsBodydeleteAgent
  * @param opt ajax config
  * @returns models.ApiResponseVoid
  */
const deleteAgent = (params, data, opt) => {
    const path = '/agent/delete';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsdeleteMarioAgentThreadMessages
  * @param data: ParamsBodydeleteMarioAgentThreadMessages
  * @param opt ajax config
  * @returns models.ApiResponseVoid
  */
const deleteMarioAgentThreadMessages = (params, data, opt) => {
    const path = '/agent/mario-agent/threads/messages/delete';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 头像上传完成回调（前端直传）
  * @param params ParamsfinishIconUpload
  * @param data: ParamsBodyfinishIconUpload
  * @param opt ajax config
  * @returns models.ApiResponseString
  */
const finishIconUpload = (params, data, opt) => {
    const path = '/agent/icon/upload-finish';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsgetAgentFullDetail
  
  * @param opt ajax config
  * @returns models.ApiResponseAgentFullDetailVO
  */
const getAgentFullDetail = (params, opt) => {
    const path = '/agent/full-detail';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('marioAgentId' in params)
        p.query.marioAgentId = params.marioAgentId;
    ajax.check(params.marioAgentId, 'marioAgentId');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsgetAgentModel
  
  * @param opt ajax config
  * @returns models.ApiResponseString
  */
const getAgentModel = (params, opt) => {
    const path = '/agent/model';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('marioAgentId' in params)
        p.query.marioAgentId = params.marioAgentId;
    ajax.check(params.marioAgentId, 'marioAgentId');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 必传参数:marioAgentId
  * @summary 根据marioAgentId获取权限详情
  * @param params ParamsgetAgentPermissionDetail
  
  * @param opt ajax config
  * @returns models.ApiResponseMarioAgentPermissionConfigPO
  */
const getAgentPermissionDetail = (params, opt) => {
    const path = '/agent/agent/permission/detail';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('marioAgentId' in params)
        p.query.marioAgentId = params.marioAgentId;
    ajax.check(params.marioAgentId, 'marioAgentId');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsgetAgentPresets
  
  * @param opt ajax config
  * @returns models.ApiResponseMapStringAgentModelConfig
  */
const getAgentPresets = (params, opt) => {
    const path = '/agent/presets';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsgetChatHistory
  
  * @param opt ajax config
  * @returns models.ApiResponseString
  */
const getChatHistory = (params, opt) => {
    const path = '/agent/chat/history';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('marioAgentId' in params)
        p.query.marioAgentId = params.marioAgentId;
    ajax.check(params.marioAgentId, 'marioAgentId');
    if ('sessionKey' in params)
        p.query.sessionKey = params.sessionKey;
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsgetDefaultSkills
  
  * @param opt ajax config
  * @returns models.ApiResponseListAgentSkillVO
  */
const getDefaultSkills = (params, opt) => {
    const path = '/agent/default-skills';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 获取头像上传令牌（前端直传）
  * @param params ParamsgetIconUploadToken
  
  * @param opt ajax config
  * @returns models.ApiResponseIconUploadTokenResponse
  */
const getIconUploadToken = (params, opt) => {
    const path = '/agent/icon/upload-token';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsgetUserModelInfo
  
  * @param opt ajax config
  * @returns models.ApiResponseUserModelInfo
  */
const getUserModelInfo = (params, opt) => {
    const path = '/agent/model/info';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 必传参数:marioAgentId
  * @summary 判断是否为官方agent
  * @param params ParamsisOfficialAgent
  
  * @param opt ajax config
  * @returns models.ApiResponseBoolean
  */
const isOfficialAgent = (params, opt) => {
    const path = '/agent/agent/isOfficialAgent';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('marioAgentId' in params)
        p.query.marioAgentId = params.marioAgentId;
    ajax.check(params.marioAgentId, 'marioAgentId');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamslistAgents
  
  * @param opt ajax config
  * @returns models.ApiResponseListAgentListVO
  */
const listAgents = (params, opt) => {
    const path = '/agent/list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 必传参数:marioAgentId
  * @summary 根据marioAgentId获取可用权限人员详情
  * @param params ParamslistAvailableMembers
  
  * @param opt ajax config
  * @returns models.ApiResponseListAgentMemberInfo
  */
const listAvailableMembers = (params, opt) => {
    const path = '/agent/agent/listAvailableMembers';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('marioAgentId' in params)
        p.query.marioAgentId = params.marioAgentId;
    ajax.check(params.marioAgentId, 'marioAgentId');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 必传参数:groupId
  * @summary 根据groupId查询群成员
  * @param params ParamslistGroupMembers
  
  * @param opt ajax config
  * @returns models.ApiResponseListKimGroupMemberDTO
  */
const listGroupMembers = (params, opt) => {
    const path = '/agent/agent/listGroupMembers';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('groupId' in params)
        p.query.groupId = params.groupId;
    ajax.check(params.groupId, 'groupId');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamslistMarioAgentThreadMessages
  
  * @param opt ajax config
  * @returns models.ApiResponseListMarioThreadConversationResponse
  */
const listMarioAgentThreadMessages = (params, opt) => {
    const path = '/agent/mario-agent/threads/{threadId}/messages';
    const url = basePath + path.replace(/(({[^}]+})|(:[^/:]+$)|(:[^:/]+))/g, all => (String(params[all.replace(/[:{}]/g, '')]) || ''));
    const p = {};
    p.query = {};
    if ('marioAgentId' in params)
        p.query.marioAgentId = params.marioAgentId;
    ajax.check(params.marioAgentId, 'marioAgentId');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    ajax.check(params.threadId, 'threadId');
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamslistMarioAgentThreads
  
  * @param opt ajax config
  * @returns models.ApiResponseListMarioThreadResponse
  */
const listMarioAgentThreads = (params, opt) => {
    const path = '/agent/mario-agent/threads';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamslistMarioAgentThreadsByAgent
  
  * @param opt ajax config
  * @returns models.ApiResponseListMarioThreadResponse
  */
const listMarioAgentThreadsByAgent = (params, opt) => {
    const path = '/agent/mario-agent/threads/by-agent';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('marioAgentId' in params)
        p.query.marioAgentId = params.marioAgentId;
    ajax.check(params.marioAgentId, 'marioAgentId');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 必传参数:无
  * @summary 获取我创建的技能列表
  * @param params ParamslistMyCreatedSkills
  
  * @param opt ajax config
  * @returns models.ApiResponseListAgentSkillVO
  */
const listMyCreatedSkills = (params, opt) => {
    const path = '/agent/skills/listMyCreatedSkills';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 必传参数:无
  * @summary 获取官方agent列表
  * @param params ParamslistOfficialAgents
  
  * @param opt ajax config
  * @returns models.ApiResponseListOfficialAgentVO
  */
const listOfficialAgents = (params, opt) => {
    const path = '/agent/agent/listOfficialAgents';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 必传参数:无
  * @summary 获取共享agent列表
  * @param params ParamslistSharedAgents
  
  * @param opt ajax config
  * @returns models.ApiResponseListAgentListVO
  */
const listSharedAgents = (params, opt) => {
    const path = '/agent/agent/listSharedAgents';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 必传参数:marioAgentId
  * @summary 根据marioAgentId获取编辑权限人员详情
  * @param params ParamslistSharedMembers
  
  * @param opt ajax config
  * @returns models.ApiResponseListAgentMemberInfo
  */
const listSharedMembers = (params, opt) => {
    const path = '/agent/agent/listSharedMembers';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('marioAgentId' in params)
        p.query.marioAgentId = params.marioAgentId;
    ajax.check(params.marioAgentId, 'marioAgentId');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 必传参数:无
  * @summary 获取共享技能列表
  * @param params ParamslistSharedSkills
  
  * @param opt ajax config
  * @returns models.ApiResponseListAgentSkillVO
  */
const listSharedSkills = (params, opt) => {
    const path = '/agent/skills/listSharedSkills';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamslistSkills
  
  * @param opt ajax config
  * @returns models.ApiResponseListAgentSkillVO
  */
const listSkills = (params, opt) => {
    const path = '/agent/skills';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('marioAgentId' in params)
        p.query.marioAgentId = params.marioAgentId;
    ajax.check(params.marioAgentId, 'marioAgentId');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsqueryShareChatHistory
  
  * @param opt ajax config
  * @returns models.ApiResponseAgentConversationShareDTO
  */
const queryShareChatHistory = (params, opt) => {
    const path = '/agent/share/chat/detail';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('shareId' in params)
        p.query.shareId = params.shareId;
    ajax.check(params.shareId, 'shareId');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsresetSession
  * @param data: ParamsBodyresetSession
  * @param opt ajax config
  * @returns models.ApiResponseString
  */
const resetSession = (params, data, opt) => {
    const path = '/agent/session/reset';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsshareChat
  * @param data: ParamsBodyshareChat
  * @param opt ajax config
  * @returns models.ApiResponseString
  */
const shareChat = (params, data, opt) => {
    const path = '/agent/share/chat';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsswitchModel
  * @param data: ParamsBodyswitchModel
  * @param opt ajax config
  * @returns models.ApiResponseVoid
  */
const switchModel = (params, data, opt) => {
    const path = '/agent/model/switch';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamssyncAgentSkills
  * @param data: ParamsBodysyncAgentSkills
  * @param opt ajax config
  * @returns models.ApiResponseVoid
  */
const syncAgentSkills = (params, data, opt) => {
    const path = '/agent/skills/sync';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsupdateAgent
  * @param data: ParamsBodyupdateAgent
  * @param opt ajax config
  * @returns models.ApiResponseVoid
  */
const updateAgent = (params, data, opt) => {
    const path = '/agent/update';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsupdateAgentFile
  * @param data: ParamsBodyupdateAgentFile
  * @param opt ajax config
  * @returns models.ApiResponseVoid
  */
const updateAgentFile = (params, data, opt) => {
    const path = '/agent/file/update';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 必传参数:editPermissionMode,availablePermissionMode,marioAgentId 选填参数:editMemberKwaiUserIds,availableMemberKwaiUserIds
  * @summary 更新agent权限
  * @param params ParamsupdateAgentPermissionMode
  * @param data: ParamsBodyupdateAgentPermissionMode
  * @param opt ajax config
  * @returns models.ApiResponseVoid
  */
const updateAgentPermissionMode = (params, data, opt) => {
    const path = '/agent/agent/updateAgentPermissionMode';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @summary 更新agentV2
  * @param params ParamsupdateAgentV2
  * @param data: ParamsBodyupdateAgentV2
  * @param opt ajax config
  * @returns models.ApiResponseVoid
  */
const updateAgentV2 = (params, data, opt) => {
    const path = '/agent/updateV2';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsupdateMarioAgentThreadTitle
  * @param data: ParamsBodyupdateMarioAgentThreadTitle
  * @param opt ajax config
  * @returns models.ApiResponseMarioThreadResponse
  */
const updateMarioAgentThreadTitle = (params, data, opt) => {
    const path = '/agent/mario-agent/threads/title/update';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsuploadAgentIcon
  
  * @param opt ajax config
  * @returns models.ApiResponseString
  */
const uploadAgentIcon = (params, opt) => {
    const path = '/agent/icon/upload';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.form = {};
    if ('file' in params)
        p.form.file = params.file;
    ajax.check(params.file, 'file');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 文档-删除
  * @param params ParamsdocDelete
  
  * @param opt ajax config
  * @returns models.ApiResultBoolean
  */
const docDelete = (params, opt) => {
    const path = '/knowledge/doc/delete';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('docId' in params)
        p.query.docId = params.docId;
    ajax.check(params.docId, 'docId');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 文档-单条详情
  * @param params ParamsdocGetOne
  
  * @param opt ajax config
  * @returns models.ApiResultAgentDocOutDTO
  */
const docGetOne = (params, opt) => {
    const path = '/knowledge/doc/get';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('docId' in params)
        p.query.docId = params.docId;
    ajax.check(params.docId, 'docId');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 文档-知识库子列表
  * @param params ParamsdocOnlineDocsKBaseSubNotes
  * @param data: ParamsBodydocOnlineDocsKBaseSubNotes
  * @param opt ajax config
  * @returns models.ApiResultListOnlineDocOutDTO
  */
const docOnlineDocsKBaseSubNotes = (params, data, opt) => {
    const path = '/knowledge/doc/onlineDocsKBaseSubNotes';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 文档-列表
  * @param params ParamsdocSearch
  * @param data: ParamsBodydocSearch
  * @param opt ajax config
  * @returns models.ApiResultPageDTOAgentDocOutDTO
  */
const docSearch = (params, data, opt) => {
    const path = '/knowledge/doc/list';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 文档-列表
  * @param params ParamsdocSearchForAgent
  * @param data: ParamsBodydocSearchForAgent
  * @param opt ajax config
  * @returns models.ApiResultListAgentDocOutSimpleDTO
  */
const docSearchForAgent = (params, data, opt) => {
    const path = '/knowledge/doc/listForAgent';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 文档-搜索在线Docs文档/知识库
  * @param params ParamsdocSearchOnlineDocs
  * @param data: ParamsBodydocSearchOnlineDocs
  * @param opt ajax config
  * @returns models.ApiResultListOnlineDocOutDTO
  */
const docSearchOnlineDocs = (params, data, opt) => {
    const path = '/knowledge/doc/onlineDocsSearch';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 文档-分段
  * @param params ParamsdocSplit
  
  * @param opt ajax config
  * @returns models.ApiResultBoolean
  */
const docSplit = (params, opt) => {
    const path = '/knowledge/doc/split';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('docId' in params)
        p.query.docId = params.docId;
    ajax.check(params.docId, 'docId');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 文档-上传Docs文档/知识库
  * @param params ParamsdocUploadDocs
  * @param data: ParamsBodydocUploadDocs
  * @param opt ajax config
  * @returns models.ApiResultListAgentDocOutDTO
  */
const docUploadDocs = (params, data, opt) => {
    const path = '/knowledge/doc/uploadDocs';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 文档-查询在线Docs文档/知识库
  * @param params ParamsonlineDocsList
  * @param data: ParamsBodyonlineDocsList
  * @param opt ajax config
  * @returns models.ApiResultListOnlineDocOutDTO
  */
const onlineDocsList = (params, data, opt) => {
    const path = '/knowledge/doc/onlineDocsList';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params Paramsdownload
  
  * @param opt ajax config
  * @returns string
  */
const download = (params, opt) => {
    const path = '/file/download';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('key' in params)
        p.query.key = params.key;
    ajax.check(params.key, 'key');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params Paramshealth
  
  * @param opt ajax config
  * @returns string
  */
const health = (params, opt) => {
    const path = '/health';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamshealthDetail
  
  * @param opt ajax config
  * @returns models.HealthDetailVO
  */
const healthDetail = (params, opt) => {
    const path = '/health/detail';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params Paramsping
  
  * @param opt ajax config
  * @returns string
  */
const ping = (params, opt) => {
    const path = '/ping';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsinviteBot2Group
  * @param data: ParamsBodyinviteBot2Group
  * @param opt ajax config
  * @returns models.ApiResponseInviteBot2GroupRes
  */
const inviteBot2Group = (params, data, opt) => {
    const path = '/kim/invite/group';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamslistGroupAgents
  * @param data: ParamsBodylistGroupAgents
  * @param opt ajax config
  * @returns models.ApiResponseListGroupAgentsResult
  */
const listGroupAgents = (params, data, opt) => {
    const path = '/kim/group/agents';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsremoveGroupAgent
  * @param data: ParamsBodyremoveGroupAgent
  * @param opt ajax config
  * @returns models.ApiResponseBoolean
  */
const removeGroupAgent = (params, data, opt) => {
    const path = '/kim/group/agent/remove';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamssearchKimGroup
  
  * @param opt ajax config
  * @returns models.ApiResponseListKimGroupDTO
  */
const searchKimGroup = (params, opt) => {
    const path = '/kim/search-group';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('keyword' in params)
        p.query.keyword = params.keyword;
    ajax.check(params.keyword, 'keyword');
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params ParamsupdateGroupAgentEnable
  * @param data: ParamsBodyupdateGroupAgentEnable
  * @param opt ajax config
  * @returns models.ApiResponseBoolean
  */
const updateGroupAgentEnable = (params, data, opt) => {
    const path = '/kim/group/agent/enable';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  *
  * @param params Paramshello
  
  * @param opt ajax config
  * @returns string
  */
const hello = (params, opt) => {
    const path = '/hello';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    return ajax.ajax({
        ...opt,
        method: 'GET',
        url,
        ...p
    });
};
/**
  * 用户自配置 QA 召回
  * @param params ParamsretrieveQa
  * @param data: ParamsBodyretrieveQa
  * @param opt ajax config
  * @returns models.ApiResultListQaRetrieveItemVO
  */
const retrieveQa = (params, data, opt) => {
    const path = '/knowledge/qa-retriever/retrieve';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};
/**
  * 召回
  * @param params Paramsretrieve
  * @param data: ParamsBodyretrieve
  * @param opt ajax config
  * @returns models.ApiResultListRetrieveSegmentVO
  */
const retrieve = (params, data, opt) => {
    const path = '/knowledge/retriever/retrieve';
    const url = basePath + path;
    const p = {};
    p.query = {};
    if ('testUser' in params)
        p.query.testUser = params.testUser;
    if ('kwaiUserId' in params)
        p.query.kwaiUserId = params.kwaiUserId;
    p.data = data;
    ajax.check(data, 'body.body');
    return ajax.ajax({
        ...opt,
        method: 'POST',
        url,
        ...p
    });
};

export { agentSkillInstallUsingPost, agentSkillRagInstallUsingPost, checkBotClaimed, createAgent, createAgentV2, deleteAgent, deleteMarioAgentThreadMessages, docDelete, docGetOne, docOnlineDocsKBaseSubNotes, docSearch, docSearchForAgent, docSearchOnlineDocs, docSplit, docUploadDocs, download, finishIconUpload, getAgentFullDetail, getAgentModel, getAgentPermissionDetail, getAgentPresets, getChatHistory, getDefaultSkills, getIconUploadToken, getUserModelInfo, health, healthCheck, healthCheck1, healthCheck2, healthCheck3, healthCheck4, healthCheck5, healthCheck6, healthDetail, hello, inviteBot2Group, isOfficialAgent, kimEventMessageCallback, kimMessageCallback, listAgents, listAvailableMembers, listGroupAgents, listGroupMembers, listMarioAgentThreadMessages, listMarioAgentThreads, listMarioAgentThreadsByAgent, listMyCreatedSkills, listOfficialAgents, listSharedAgents, listSharedMembers, listSharedSkills, listSkills, onlineDocsList, ping, queryShareChatHistory, removeGroupAgent, resetSession, retrieve, retrieveQa, searchKimGroup, shareChat, switchModel, syncAgentSkills, updateAgent, updateAgentFile, updateAgentPermissionMode, updateAgentV2, updateGroupAgentEnable, updateMarioAgentThreadTitle, uploadAgentIcon };
